import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { BreadcrumbIqbaService } from "../breadcrumbIqba/breadcrumbIqba.service";

import { BR, ESegmentTypes, HR, PlainTextService } from 'libraries/service/plainText/plainText.service';
import { ApiResourceService } from 'libraries/service/apiResource/apiResource.service';
import { IQuote } from 'libraries/model/air-quote/IQuote';
import { IGetAirTripQuotes, IQuote as IAirSearchQuote } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { IWenji } from "libraries/interfaces/IWenji";
import { IPostAirSearchRequest, IPrice, ISegment } from "libraries/interfaces/i-post-air-search-request";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
    IAirQuotedAvailabilityResponse
} from "libraries/service/resources/model/booking/air/IAirQuotedAvailabilityResponse";
import { IAirCreateBookingRequestSegment } from "libraries/service/resources/model/booking/air/IAirCreateBooking";
import { FareFamilyType } from "@afidium/ts-facade";
import { LanguageService } from "libraries/service/language/language.service";
import { CacheSamResourceService } from "libraries/service/resources/sam/cache-sam-resource.service";
import { ISamAgent } from "libraries/service/resources/sam/ISamAgent";
import { ISamCompany } from "libraries/service/resources/sam/ISamCompany";
import { flatMap } from "rxjs/internal/operators";
import { AirTripResourceService } from "libraries/service/resources/airTrip/airTripResource.service";
import _cloneDeep from "lodash-es/cloneDeep";
import * as moment from 'moment';
import { IAirSearchRequest } from "../../air-search/air-search.component";
import {
    IAirSearchSegment
} from "../../air-search/air-search-form/air-search-segment-oneway-return/air-search-segment-oneway-return.component";

declare const wenji: IWenji;

/**
 * Service for locobook first RQ : api/air/trips/search
 * also use "api/air/trips/" + this.propalResponse.data.key + "/quotes/" + bookingKey;
 * to change displayed Quote
 */
@Injectable()
export class PropalService {

    public bcItems: any = [];
    //data container
    public propalResponse: any =
        {message: "", rs: {}, firstSegments: [], display: {errorTraveller: {}}, traveller: {}};

    public plainTextResponse: any;

    //urls
    private readonly lsPrefix: string = sessionStorage.getItem("$instance_url");

    constructor(
        private readonly http: HttpClient,
        private readonly location: Location,
        private readonly plainTextService: PlainTextService,
        private readonly apiResourceService: ApiResourceService,
        private readonly breadcrumbIqba: BreadcrumbIqbaService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly languageService: LanguageService,
        private readonly cacheSamResourceService: CacheSamResourceService,
        private readonly airTripResourceService: AirTripResourceService,
        // private readonly priceSwitcherService: PriceSwitcherService,
    ) {
        this.location = location;
        this.plainTextResponse = plainTextService.response;
        this.bcItems = breadcrumbIqba.items;
    }

    public initPropalResponse(): void {
        this.propalResponse = {message: "", rs: {}, firstSegments: [], display: {errorTraveller: {}}, traveller: {}};
    }

    public getPropalWithKeys(idSearch: string, idQuote: string, flexibility?: number): Observable<IQuote> {
        return this.apiResourceService.getOne(
            this.apiResourceService.getApiUrl('air', 'trips', idSearch, 'quotes', idQuote),
            {},
            {target: wenji.ui.target}
        );
    }

    public getPropalData(bodyArg: IAirSearchRequest, mustStoreInitialRequest: boolean = true): Observable<IGetAirTripQuotes> {
        let body: IAirSearchRequest = _cloneDeep(bodyArg);
        const languageCode: string = this.languageService.getUserLanguage();
        const userInfo = JSON.parse(sessionStorage.getItem("userInformations")); //TODO get user with a better way
        const userId: number = userInfo.sam_contact.id;
        const companyId: number = userInfo.sam_company;
        return this.cacheSamResourceService.getAgentAndCompany(userId, companyId)
            .pipe(
                flatMap(([samAgent, samCompany]: [ISamAgent, ISamCompany]): Observable<IGetAirTripQuotes> => {
                    // @ts-ignore
                    if (!body.agency) {
                        // @ts-ignore
                        body.agency = samCompany;
                        // @ts-ignore
                    } else if (!body.agency.address) {
                        // @ts-ignore
                        body.agency.address = samCompany.address;
                    }
                    // @ts-ignore
                    if (!body.agent) {
                        // @ts-ignore
                        body.agent = samAgent;
                    }

                    // @ts-ignore
                    if (body.traveller?.length) {
                        // @ts-ignore
                        body.traveller = body.traveller.map((traveller: any): any => {
                            if (traveller.birthDate && typeof traveller.birthDate === "object") {
                                traveller.birthDate = moment(traveller.birthDate as Date).format('YYYY-MM-DD');
                            }
                            return traveller;
                        });
                    }
                    body = {
                        ...body,
                        segment: body.segment.map((segmentItem: IAirSearchSegment): IAirSearchSegment => {
                            let begin: any = segmentItem.begin;
                            if (typeof begin === 'string') {
                                begin = begin.split('T')[0];
                            }
                            if (begin?.value && begin.value instanceof Date) {
                                begin.value = moment(begin.value as Date).format('YYYY-MM-DD');
                            }
                            //TODO : Do the same for Time
                            if (begin instanceof Date) {
                                begin = moment(begin as Date).format('YYYY-MM-DD');
                            }
                            return {
                                ...segmentItem,
                                begin
                            };
                        }),
                    };

                    if (mustStoreInitialRequest) {
                        body.initialisationRequestContent = bodyArg;
                    }
                    const initialisationRequestClone: IAirSearchRequest = body.initialisationRequestContent;

                    if (Boolean(initialisationRequestClone?.price)) {
                        const formPriceKeys: string[] = ['fareType', 'minus', 'value'];
                        formPriceKeys.forEach((key: string): void => {
                            if (initialisationRequestClone.price[key]) {
                                // tslint:disable-next-line:no-dynamic-delete
                                delete initialisationRequestClone.price[key];
                            }
                        });
                    }

                    // @ts-ignore
                    const price: IPrice = (Boolean(initialisationRequestClone?.price) || Boolean(body.price)) ?
                        {
                            ...(initialisationRequestClone?.price || {}),
                            ...(body.price || {})
                        } : null;

                    return this.airTripResourceService.search({
                        ...(body as unknown as IPostAirSearchRequest),
                        price,
                        languageCode
                    });
                })
            );

    }

    private getAirSearchBodyFilterNull(airSearchBody: IAirSearchRequest): IAirSearchRequest {
        Object.keys(airSearchBody).forEach((key: string) => {
            if (airSearchBody[key] === null || Object.keys(airSearchBody[key]).length === 0) {
                delete airSearchBody[key];
            }
        });
        return airSearchBody;
    }

    public getPropalDataForSilentBooking(body: IPostAirSearchRequest): Observable<any> {

        const languageCode: string = this.languageService.getUserLanguage();

        return this.airTripResourceService.search({
            ...body,
            languageCode
        });

    }

    public getSearchRequest(idTrip: string): Observable<any> {

        return this.apiResourceService.getOne(
            this.apiResourceService.getApiUrl('air', 'trips', idTrip, 'request'),
            {},
            {target: wenji.ui.target}
        );
    }

    public setPropalResponseData(data: IGetAirTripQuotes): void {
        this.propalResponse.data = data;
    }

    public setPropalDisplay(segments: string[], selectedJourneys: string[]): void {
        this.propalResponse.display.segments = segments;
        this.propalResponse.display.selectedJourneys = selectedJourneys;
    }

    /**
     * Store result for components
     * this.propalResponse.data : response datas
     * this.propalResponse.display : infos for displaying infos
     */
    public storeResult(res: any, resetLocation: boolean = true): void {

        //store datas and errors
        this.propalResponse.message = res.message;
        this.propalResponse.data = res;

        //set selected booking and journeys
        this.selectQuote(this.propalResponse.data.booking, resetLocation);

        //set travelers, and travellers errors
        if (this.propalResponse.data.booking[this.propalResponse.display.booking].traveller
            || this.propalResponse.data.booking[this.propalResponse.display.booking].traveller != null) {

            this.verifyAPIS();
        }

        this.plainTextResponse.dictionary = res.dictionary;

        //Activate traveller link in breadcrumb
        this.breadcrumbIqba.setClickable(1, true);
    }

    public selectQuote(booking: object, resetLocation: boolean = true, carrierDictionary?: object): void {

        const bookingKey: string = Object.keys(booking)[0];
        let bookingContent = booking[bookingKey];
        this.propalResponse.display.booking = bookingKey;
        this.propalResponse.data.booking[bookingKey] = booking[bookingKey];
        if (carrierDictionary) {
            this.propalResponse.data.booking[bookingKey].vendor = this.getCarrierNameFromDictionary(
                bookingContent.vendor.code ?
                    bookingContent.vendor.code :
                    bookingContent.vendor,
                carrierDictionary);
        }

        this.propalResponse.display.segments = Object.keys(booking[bookingKey].segment);

        this.propalResponse.display.firstSegments = this.parseSegment(this.propalResponse.data.booking[bookingKey]);


        this.propalResponse.display.selectedJourneys =
            this.getFirstJourneyId(this.propalResponse.data.booking[bookingKey]);


        //set route
        if (resetLocation) {
            this.location.replaceState(`locobook/search/${this.propalResponse.data.key}/${this.propalResponse.display.booking}`);
        }
    }

    private getCarrierNameFromDictionary(code: string, carriersDictionary: object): {
        code: string,
        name: string
    } | null {
        if (carriersDictionary) {
            return carriersDictionary[code] ?? code;
        }
        return null;
    }

    public storeQuote(booking: object): void {
        const bookingKey = Object.keys(booking)[0];
        this.propalResponse.data.booking[bookingKey] = booking[bookingKey];
    }

    /*
    * getQuote
    * RQ to get a Booking from is Id
    * @bookingKey : booking key
    */
    public getQuote(bookingKey: string, selectbooking: boolean = false): void {
        const apiUrl = sessionStorage.getItem("$instance_url") +
            `api/air/trips/${this.propalResponse.data.key}/quotes/${bookingKey}`;

        const headers =
            new HttpHeaders({
                'Content-Type': 'application/json',
                'xtoken': localStorage.getItem(this.lsPrefix + "_token"),
                target: wenji.ui.target,
            });
        // Create a request option
        const options = {headers};

        this.http.get(apiUrl, options)
            .subscribe((res: Response) => {
                    // @ts-ignore
                    this.storeQuote(res.data.booking);
                    if (selectbooking) {
                        // @ts-ignore
                        this.selectQuote(res.data.booking);
                    }
                },
                (error: any) => {
                    if (error) {
                        this.errorTracingService.captureException(error);
                    }

                });
    }

    /*
    * http://projets2.afidium.com/issues/13225#note-8
    * 3 datas can break PNR creation
    * birthDate
    * passport.*
    * citizenship
    * If One or two is present, but not all, NOK
    * If none present, OK
    */
    public verifyAPIS(): void {
        const apisListAdult: string[] = [
            "birthDate", "passport", "citizenship"
        ];
        const apisListChild: string[] = [
            "passport", "citizenship"
        ];
        const passportFields: string[] = ['number', 'validity', 'issuance'];

        this.propalResponse.display.errorTraveller = {};

        // tslint:disable-next-line:no-any
        const travellers: any = {...this.propalResponse.traveller};
        const travellerKeys: string[] = Object.keys(travellers);
        for (const travellerKey of travellerKeys) {
            const apisList: string[] =
                travellers[travellerKey].type === 'INFANT' || travellers[travellerKey].type === 'CHILD' ?
                    apisListChild :
                    apisListAdult;
            //let nbPresent = 0;

            this.propalResponse.display.errorTraveller[travellerKey] = [];
            if (travellers[travellerKey].identityType) {
                if (travellers[travellerKey].identityType === 'passport' && travellers[travellerKey].passport) {

                    // tslint:disable-next-line:no-any
                    const id: any = {
                        number: (travellers[travellerKey].passport.passNumber || travellers[travellerKey].passport.number),
                        validity: {
                            end: travellers[travellerKey].passport.validity ?
                                (travellers[travellerKey].passport.validity.passEnd || travellers[travellerKey].passport.validity.end) :
                                null,
                        },
                        issuance: {
                            country: travellers[travellerKey].passport.issuance ?
                                (travellers[travellerKey].passport.issuance.passCountry || travellers[travellerKey].passport.issuance.country) :
                                null,
                        },
                    };
                    travellers[travellerKey].passport = id;
                    travellers[travellerKey].citizenship = (travellers[travellerKey].passportCitizenship || travellers[travellerKey].citizenShip);
                }
                if (travellers[travellerKey].identityType === 'identityCard' && travellers[travellerKey].identityCard) {
                    const id: any = {
                        number: (travellers[travellerKey].identityCard.cardNumber || travellers[travellerKey].identityCard.number),
                        validity: {
                            end: travellers[travellerKey].identityCard.validity ?
                                (travellers[travellerKey].identityCard.validity.cardEnd || travellers[travellerKey].identityCard.validity.end) :
                                null,
                        },
                        issuance: {
                            country: travellers[travellerKey].identityCard.issuance ?
                                (travellers[travellerKey].identityCard.issuance.cardCountry || travellers[travellerKey].identityCard.issuance.country) :
                                null,
                        },
                    };
                    travellers[travellerKey].identityCard = id;
                    travellers[travellerKey].citizenship = (travellers[travellerKey].identityCardCitizenship || travellers[travellerKey].citizenShip);

                }
            }

            //test if absents


            if (travellers[travellerKey].passport) {
                for (const apisName of apisList) {
                    if (!travellers[travellerKey][apisName]) {
                        this.propalResponse.display.errorTraveller[travellerKey].push(apisName);
                    }
                }
                for (const passportField of passportFields) {
                    if (!travellers[travellerKey].passport[passportField]) {
                        this.propalResponse.display.errorTraveller[travellerKey].push(`pp${passportField}`);
                    }
                }
            }
        }
    }

    /**
     * store plainText transltion of journeys
     */
    public getPlainText(bookingId: string, quote: IAirSearchQuote, segment: string[], journey: string[]): string {

        const br: string = BR;
        const hr: string = HR;

        //Create plainText object if don't exist
        if (!this.propalResponse.display.plainText) {
            this.propalResponse.display.plainText = {};
        }

        //send each journey of each segment
        let output: string = "";

        segment.forEach((seg: string, i: number): void => {
            let segmentType: ESegmentTypes = "" as ESegmentTypes;
            //XXX: correct only for AR trip
            if (segment.length === 2) {
                if (i === 0) {
                    segmentType = ESegmentTypes.aller;
                }
                if (i === 1) {
                    segmentType = ESegmentTypes.retour;
                }
            } else if (segment.length > 2) {
                segmentType = ESegmentTypes.multi;
            }

            const text: string = this.plainTextService.setPlainText(
                quote.segment[seg][journey[i]],
                true,
                segmentType,
                i
            );

            //create objects if don't exist
            if (!this.propalResponse.display.plainText[bookingId]) {
                this.propalResponse.display.plainText[bookingId] = {};
            }
            if (!this.propalResponse.display.plainText[bookingId][seg]) {
                this.propalResponse.display.plainText[bookingId][seg] = {};
            }
            this.propalResponse.display.plainText[bookingId][seg][journey[i]] = text;
            output += text;
        });

        output += br;
        output += hr;
        segment.forEach((seg: string, i: number): void => {
            output += this.plainTextService.setShortPlainText(
                quote.segment[seg][journey[i]],
                true);

        });


        return output;
    }

    public storeSelectedQuote(quote: IAirQuotedAvailabilityResponse, quoteId?: string): void {
        if (!this.propalResponse.data) {
            this.propalResponse.data = {};
        }
        if (quoteId) {
            this.propalResponse.display.booking = quoteId;
        }
        this.propalResponse.display.segments = Object.keys(quote.segment);
        this.propalResponse.data.selectedQuote = quote;
        this.propalResponse.data.selectedQuoteJourneys = Object.values(quote.segment)
            // @ts-ignore
            .flatMap((segment: IAirCreateBookingRequestSegment): string[] => segment.journey);
        if (!this.propalResponse.data.dictionary) {
            this.propalResponse.data.dictionary = {};
        }
        if (!this.propalResponse.data.dictionary.fareFamily) {
            this.propalResponse.data.dictionary.fareFamily = {};
        }
        (quote.fareFamilyDictionary || []).forEach((fareFamily: FareFamilyType): void => {
            if (!this.propalResponse?.data?.dictionary?.fareFamily) {
                this.propalResponse.data.dictionary.fareFamily = {
                    [fareFamily.xId]: fareFamily,
                };
            } else {
                this.propalResponse.data.dictionary.fareFamily[fareFamily.xId] = fareFamily;
            }
        });

    }

    private parseSegment(bookingQ: any): any {
        const bookingSegments = bookingQ.segment;
        const segments = [];

        for (const key in bookingSegments) {
            if (bookingSegments.hasOwnProperty(key)) {
                const value = bookingSegments[key];
                segments.push(value);
            }
        }

        return segments;

    }

    private getFirstJourneyId(bookingItem: any): any {
        const bookingSegments = bookingItem.segment;
        const journeys = [];

        for (const key in bookingSegments) {
            // check also if property is not inherited from prototype
            if (bookingSegments.hasOwnProperty(key)) {
                const value = bookingSegments[key].journey[0];
                journeys.push(value);
            }
        }

        return journeys;

    }

}
